import React from 'react'
import Select from 'react-select'

const SelectBox = ({ ...props }) => {
    return (
        <Select isClearable={true} {...props} />
    )
}

export default SelectBox